module.exports = "<span>\r\n    <span ng-click=\"$ctrl.callDownload()\"\r\n          ng-if=\"!$ctrl.showProgress\">{{::$ctrl.title}}</span>\r\n\t<span ng-click=\"$ctrl.cancelDownload()\"\r\n         ng-if=\"$ctrl.showProgress && !$ctrl.progressTitle\"\r\n         class=\"app-button app-button--raised\"\r\n         translate>\r\n        Cancel download\r\n    </span>\r\n\t<span ng-if=\"$ctrl.showProgress && $ctrl.progressTitle\"\r\n         translate>\r\n        In Progress...\r\n    </span>\r\n</span>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/download-element/label/label.html
// module id = 1844
// module chunks = 0